import React, { FC, useEffect } from 'react';
import { SearchInputSmall } from '../common/SearchInputSmall';
import { ButtonComponent } from '../ButtonComponent';
import { fetchActivityLogList } from '../../store/order/actions/activity-log';
import { useOrdersContext } from '../../store/order/order-context';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { checkIfValidUUID } from '../../layout/core';

interface Props {
  tenantId: string;
  setTenantId: (value: string) => void;
  correlationId: string;
  setCorrelationId: (value: string) => void;

}
export const ActivityLogFilters: FC<Props> = (props) => {
  const { tenantId, setTenantId, correlationId, setCorrelationId } = props;

  const { orderContextState: { activityLogTablePageSize }, dispatch } = useOrdersContext();
  const { merchantState: { chosenMerchant }} = useMerchants();

  const [showMidError, setShowMidError] = React.useState<boolean>(false);
  const [showOrderIdError, setShowOrderIdError] = React.useState<boolean>(false);
  const [midErrorMessage, setMidErrorMessage] = React.useState<string>('');
  const [orderIdErrorMessage, setOrderIdErrorMessage] = React.useState<string>('');
  const handleSearch = async (): Promise<void> => {
    if (!tenantId || (tenantId && !checkIfValidUUID(tenantId)) || (correlationId && !checkIfValidUUID(correlationId))) {
      if (!tenantId) {
        setShowMidError(true);
        setMidErrorMessage('Mid is required');
      }
      if (tenantId && !checkIfValidUUID(tenantId)) {
        setShowMidError(true);
        setMidErrorMessage('Please, enter valid id');
      }
      if (correlationId && !checkIfValidUUID(correlationId)) {
        setShowOrderIdError(true);
        setOrderIdErrorMessage('Please, enter valid id');
      }
      return;
    }
    if (tenantId && checkIfValidUUID(tenantId)) {
      await fetchActivityLogList(dispatch, 1, activityLogTablePageSize, chosenMerchant, tenantId, correlationId);
      setShowMidError(false);
      setMidErrorMessage('');
    }
  };

  useEffect(() => {
    setShowOrderIdError(false);
    setOrderIdErrorMessage('');
    setShowMidError(false);
    setMidErrorMessage('');
  }, [tenantId, correlationId]);

  return (
    <div className="card bg-transparent mb-10">
      <div className="card-body px-0 py-0">
        <div className="d-md-flex align-items-center">
          <div className="d-sm-flex align-items-center">
            <SearchInputSmall
              placeholder="Search by mid"
              additionalClass="mb-5 mb-md-0"
              searchValue={tenantId}
              setSearchValue={setTenantId}
              showError={showMidError}
              errorMessage={midErrorMessage}
            />
            <SearchInputSmall
              placeholder="Search by order id"
              additionalClass="mb-5 mb-md-0 ms-sm-10"
              searchValue={correlationId}
              setSearchValue={setCorrelationId}
              showError={showOrderIdError}
              errorMessage={orderIdErrorMessage}
            />
          </div>

          <ButtonComponent
            buttonName="Search"
            additionalClass="d-block ms-auto btn-sm ms-md-10"
            onButtonClick={handleSearch}
          />
        </div>
      </div>
    </div>
  );
};